function refreshCollectionPageWithFilters(url_filters) {

  let currentUrl = '//' + location.host + location.pathname;
  let newPageString = httpGet(currentUrl + '?' + url_filters);
  let newPageEl = document.createElement('DIV');
  newPageEl.innerHTML = newPageString;

  var newSection = newPageEl.querySelector('.mm-collection-grid');

  document.querySelector('.mm-collection-grid').innerHTML = newSection.innerHTML;
  window.history.replaceState(null, document.title, currentUrl + '?' + url_filters);

  var newCount = newPageEl.querySelector('.filter-form');

  document.querySelector('.filter-form').innerHTML = newCount.innerHTML;
  window.history.replaceState(null, document.title, currentUrl + '?' + url_filters)
}

function httpGet(theUrl) {
  var xmlHttp = null;

  xmlHttp = new XMLHttpRequest();
  xmlHttp.open( "GET", theUrl, false );
  xmlHttp.send( null );
  return xmlHttp.responseText;
}

function checkForChanges(){
var form = document.getElementById('collectionFacetsForm');
var inputs = form.querySelectorAll('input');
var selects = form.querySelectorAll('select');

inputs.forEach(function(input){
  input.addEventListener('change', function(e){
    fakeSubmitForm();
  })
})
selects.forEach(function(select){
  select.addEventListener('change', function(e){
    fakeSubmitForm();
  })
})
}

function fakeSubmitForm() {
let url_filters = $('#collectionFacetsForm').serialize();
refreshCollectionPageWithFilters(url_filters);
}

window.addEventListener("DOMContentLoaded", (event) => {
checkForChanges();
});

// // Rotation des flèches

// function toggleRotate(svgElement) {
//   var rotationActive = svgElement.getAttribute("data-rotation");

//   if (!rotationActive || rotationActive === "false") {
//     svgElement.style.transform = "rotate(180deg)";
//     svgElement.setAttribute("data-rotation", "true");
//   } else {
//     svgElement.style.transform = "rotate(0deg)";
//     svgElement.setAttribute("data-rotation", "false");
//   }
// }


// Fonction pour fermer le filter-group quand on clique ailleur
document.addEventListener('click', function(event) {
  var filterGroupDisplays = document.querySelectorAll('.filter-group-display');

  filterGroupDisplays.forEach(function(display) {
    if (!display.contains(event.target)) {
      var filterGroup = display.closest('.filter-group');
      if (filterGroup) {
        filterGroup.removeAttribute('open');
      }
    }
  });

  var filterGroupSummaries = document.querySelectorAll('.mm-mcpg-filter');

  filterGroupSummaries.forEach(function(summary) {
    if (summary.contains(event.target)) {
      var filterGroup = summary.closest('.filter-group');
      if (filterGroup) {
        if (filterGroup.hasAttribute('open')) {
          filterGroup.removeAttribute('open');
        } else {
          return;
        }
      }
    }
  });
});
